import { render, staticRenderFns } from "./transportes.vue?vue&type=template&id=436b4574&"
import script from "./transportes.vue?vue&type=script&lang=js&"
export * from "./transportes.vue?vue&type=script&lang=js&"
import style0 from "./transportes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports